import React from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../Components/Navbar/Navbar";
import ProductCard from "../Components/ProductCard/ProductCard";
import Footer from "../Components/Footer/Footer";
import { Box } from "@mui/material";
import CardImg from "../Assets/pistachio_croissant.png";
import useMetaTracking from "../hooks/useMetaTracking";

function PistachioCroissant() {
  useMetaTracking("ViewContent", {
    content_name: "Pistachio Croissant",
    content_category: "Pastries",
    content_ids: ["pistachio_croissant"],
    content_type: "pastries",
    value: 5.50,
    currency: "USD",
  });

  const pageTitle = "Pistachio Croissant | Đông Hưng Viên Bakery";
  const pageDescription =
    "Rich pistachio filling meets buttery layers in a croissant that feels smooth, glossy, and straight-up indulgent.";

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:image" content={CardImg} />
      </Helmet>

      <Box className="product-page" sx={{ pt: 10, background: "#0f0f0f", color: "#fff" }}>
        <Navbar />
        <ProductCard
          cardImg={CardImg}
          titleHead="Pistachio Croissant"
          titleSubHead="$5.50 each"
          detailBody="Rich pistachio filling meets buttery layers in a croissant that feels smooth, glossy, and straight-up indulgent."
          detailBodyBr="Contains: wheat, dairy, almond, pistachio"
          ProductCardBtn="View Full Regular Menu"
          btnLink="/regular-menu"
        />
        <Footer />
      </Box>
    </>
  );
}

export default PistachioCroissant;